import { XIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/ui/icon'

import { ToastTypeToIconMap } from './toast.constants'
import * as S from './toast.styled'
import { ToastProps } from './toast.types'

export const Toast = ({
  type,
  message,
  description,
  isExiting,
  onClose,
  onMouseEnter,
  onMouseLeave,
}: ToastProps) => {
  const { t } = useTranslation(['common'])

  return (
    <S.Toast
      $type={type}
      $isExiting={isExiting}
      // Note: an error interrupts the screen reader, a success waits for it to finish
      role={type === 'error' ? 'alert' : 'status'}
      data-component-id="Toast"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <S.Content>
        <Icon icon={ToastTypeToIconMap[type]} size="2rem" />
        <S.Text>
          <S.Message>{message}</S.Message>
          {description && <S.Description>{description}</S.Description>}
        </S.Text>
      </S.Content>
      <S.CloseButton type="button" aria-label={t('common:toast.close')} onClick={onClose}>
        <Icon icon={XIcon} size="2rem" />
      </S.CloseButton>
    </S.Toast>
  )
}
